
function initAccordionSlider() {
	try {
		
			$('.Product-description__btn--js').click(function () {
				$(this).toggleClass('Button--gray-active').next().slideToggle();
				$('.Product-description__btn--js').not(this).removeClass('Button--gray-active').next().slideUp();
					});
	}
	catch {
		console.log("Ошибка initAccordionSlider()");
	}
}